export const getViewportSize = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
};
